<script>
import { mapState } from "vuex";
export default {
  title: "Dashboard",
  computed: {
    ...mapState("user", ["firstName", "lastName", "email"])
  }
};
</script>

<template>
  <div>
    <img
      src="/static/DASHBOARD_1.png"
      :class="{ show: email == 'manager@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_1.png"
      :class="{ show: email == 'luiz@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_1.png"
      :class="{ show: email == 'ruben@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_1.png"
      :class="{ show: email == 'janine@donamaid.com' }"
    />

    <img
      src="/static/DASHBOARD_2.png"
      :class="{ show: email == 'munique@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_2.png"
      :class="{ show: email == 'alana@donamaid.com' }"
    />

    <img
      src="/static/DASHBOARD_3.png"
      :class="{ show: email == 'kellerson@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_3.png"
      :class="{ show: email == 'luiza@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_3.png"
      :class="{ show: email == 'andre@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_3.png"
      :class="{ show: email == 'danielle@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_3.png"
      :class="{ show: email == 'camila.mascarenhas@donamaid.com' }"
    />

    <img
      src="/static/DASHBOARD_4.png"
      :class="{ show: email == 'erick@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_4.png"
      :class="{ show: email == 'joao@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_4.png"
      :class="{ show: email == 'gustavo@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_4.png"
      :class="{ show: email == 'guilherme@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_4.png"
      :class="{ show: email == 'camila@donamaid.com' }"
    />

    <img
      src="/static/DASHBOARD_5.png"
      :class="{ show: email == 'jessica@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_5.png"
      :class="{ show: email == 'tais@donamaid.com' }"
    />
    <img
      src="/static/DASHBOARD_5.png"
      :class="{ show: email == 'patrick@donamaid.com' }"
    />
  </div>
</template>

<style scoped>
img {
  display: none;
  width: 100%;
  object-fit: contain;
  user-select: none;
}

img.show {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue